// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-comparison[data-v-1876c4d2]{padding:14px 0}.e-comparison__text[data-v-1876c4d2]{font-size:.75rem;font-weight:400;white-space:nowrap}.e-comparison__progress[data-v-1876c4d2]{border-radius:6px;margin-top:5px}.e-comparison__progress[data-v-1876c4d2] .v-progress-linear__determinate{border-radius:6px}", ""]);
// Exports
module.exports = exports;
